<div [formGroup]="customAttributeSectionForm" class="form flex flex-col">
  <nx-edit-text-input
    formControlName="externalId"
    placeholder="coreModuleModule.customAttributeSectionDialogComponent.form.externalId.placeholder"
    label="coreModuleModule.customAttributeSectionDialogComponent.form.externalId.label">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="label"
    placeholder="coreModuleModule.customAttributeSectionDialogComponent.form.url.placeholder"
    label="coreModuleModule.customAttributeSectionDialogComponent.form.url.label">
  </nx-edit-text-input>
  <nx-edit-number-input
    formControlName="index"
    [placeholder]="'1'"
    [helpText]="isAdmin() ? 'coreModuleModule.customAttributeSectionDialogComponent.form.index.helpTextAdmin' : 'coreModuleModule.customAttributeSectionDialogComponent.form.index.helpText'"
    label="coreModuleModule.customAttributeSectionDialogComponent.form.index.label">
  </nx-edit-number-input>
<div>